<template>
    <div>
        <multiselect
            v-model="selected"
            :options="options"
            label="text"
            track-by="value"
            :placeholder="$t('select')"
            :multiple="multiple"
            :close-on-select="!multiple"
            :clear-on-select="!multiple"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
            @input="handleInput($event, multiple)"
        >
            <template slot="selection" slot-scope="{values, search, isOpen}">
                <span class="multiselect__single" v-if="values.length && !isOpen">
	                {{ translateNSelected(values) }}
                </span>
            </template>
            <span slot="noOptions">{{ $t("no_options") }}</span>
            <span slot="noResult">{{ $t("no_result") }}</span>
        </multiselect>
        <span class="invalid-feedback-custom"
              v-show="validateError"
              v-html="validateError"/>
    </div>
</template>

<script>
// Helpers
import translateNSelected from "@/helpers/translateNSelected";
import handleInput from "@/helpers/handleInput";
import setSelected from "@/helpers/setSelected";

// Services
import PaymentService from "@/services/PaymentService";

export default {
    props: {
        value: {
            default: null
        },
        validateError: {
            type: String,
            default: ''
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        onlyActive: {
            type: Boolean,
            default: false,
        },
        onlyYearly: {
            type: Boolean,
            default: false,
        },
        semesters: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            selected: null,
            options: [],
        }
    },
    watch: {
        value: function (newValue) {
            this.selected = this.setSelected(newValue, this.options, this.multiple)
        }
    },
    created() {
        this.getOptions();
    },
    methods: {
        translateNSelected: translateNSelected,
        handleInput: handleInput,
        setSelected: setSelected,
        getOptions() {
            const key = 'finance_periods';
            let local = this.getWithExpiry(key);
            if (local) {
                this.setOptions(local);
                this.selected = this.setSelected(this.value, this.options, this.multiple)
                return;
            }
            this.options = [];
            let params = {};
            if (this.onlyActive) {
                params.only_active = true;
            }
            if (this.onlyYearly) {
                params.only_yearly = true;
            }
            PaymentService.options({params: params})
                .then(response => {
                    const data = response.data.data;
                    this.setWithExpiry(key, data);
                    this.setOptions(data);
                })
                .then(() => {
                    this.selected = this.setSelected(this.value, this.options, this.multiple)
                })
        },
        setOptions(data){
            data.forEach((item) => {
                if (this.semesters && !this.semesters.includes(item.semester)) {
                    return;
                }
                this.options.push({
                    value: item.id,
                    text: item.code,
                });
            });
        },
        getItem(id){
            let found=null
            this.options.forEach((item)=>{
                if(item.value===id){
                    found = item;
                }
            });
            return found;
        }
    }
}
</script>
